<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">Wachtwoord reset studenten</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Filter"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>

		<v-alert v-if="loadError" type="error" dense outlined class="mx-4 mb-0">
			{{ loadError }}
		</v-alert>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:item.action="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							small
							color="primary"
							v-bind="attrs"
							v-on="on"
							:disabled="resetting"
							@click="openReset(item)"
						>
							<v-icon>mdi-lock-reset</v-icon>
						</v-btn>
					</template>
					<span>Wachtwoord resetten</span>
				</v-tooltip>
			</template>
		</v-data-table>

		<v-dialog v-model="confirmDialog" max-width="480">
			<v-card>
				<v-card-title>Wachtwoord resetten?</v-card-title>
				<v-card-text v-if="selected">
					<p class="body-2">
						Er wordt een nieuw tijdelijk wachtwoord aangemaakt voor
						<strong>{{ studentName(selected) }}</strong>
						(<strong>{{ osbodEmail(selected) }}</strong>).
					</p>
					<p class="body-2 mb-0">
						De bevestiging wordt verstuurd naar
						<strong>{{ personalEmail(selected) }}</strong>
						met de coordinator in de cc.
					</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text :disabled="resetting" @click="confirmDialog = false">Annuleren</v-btn>
					<v-btn color="primary" depressed :loading="resetting" @click="confirmReset">
						Resetten
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar" :color="snackbarColor" top right :timeout="8000">
			{{ snackbarText }}
		</v-snackbar>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";
import { effectiveDashboardRoleId } from "../../router/authMeta";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 90000
});

export default {
	name: "StudentPasswordReset",
	data() {
		return {
			user: JSON.parse(localStorage.getItem("user")),
			search: "",
			loading: false,
			resetting: false,
			loadError: "",
			data: [],
			confirmDialog: false,
			selected: null,
			snackbar: false,
			snackbarText: "",
			snackbarColor: "success",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Mutatie", value: "tbl_sys_registration_type.name" },
				{ text: "Schooljaar", value: "tbl_sys_schoolyear.name" },
				{ text: "ID-nummer", value: "tbl_student.government_id" },
				{ text: "Voornaam", value: "tbl_student.firstname" },
				{ text: "Achternaam", value: "tbl_student.surname" },
				{ text: "Opleiding", value: "tbl_sys_study.name" },
				{ text: "Klas", value: "tbl_sys_class.name" },
				{ text: "E-mail", value: "tbl_student.email" },
				{ text: "E-mail OSBOD", value: "tbl_student.osbod_email" }
			]
		};
	},
	computed: {
		roleId: function() {
			return effectiveDashboardRoleId(this.user);
		}
	},
	created: function() {
		this.getStudents();
	},
	methods: {
		studentName: function(item) {
			if (!item || !item.tbl_student) {
				return "";
			}
			var student = item.tbl_student;
			if (student.display_name) {
				return student.display_name;
			}
			return [student.firstname, student.surname].filter(Boolean).join(" ");
		},
		osbodEmail: function(item) {
			return item && item.tbl_student ? item.tbl_student.osbod_email : "";
		},
		personalEmail: function(item) {
			return item && item.tbl_student ? item.tbl_student.email : "";
		},
		showSnack: function(text, color) {
			this.snackbarText = text;
			this.snackbarColor = color || "success";
			this.snackbar = true;
		},
		openReset: function(item) {
			this.selected = item;
			this.confirmDialog = true;
		},
		getStudents: function() {
			var self = this;
			this.loading = true;
			this.loadError = "";
			ax.get("/student_password_reset/all", {
				params: {
					user_id: this.user && this.user.id,
					role_id: this.roleId
				}
			})
				.then(function(response) {
					self.data = response.data || [];
					self.loading = false;
				})
				.catch(function(err) {
					self.loading = false;
					self.data = [];
					self.loadError =
						(err.response && err.response.data && err.response.data.msg) ||
						"Studenten konden niet worden geladen.";
				});
		},
		confirmReset: function() {
			var self = this;
			if (!this.selected) {
				return;
			}
			this.resetting = true;
			ax.post("/student_password_reset/reset", {
				student_class_id: this.selected.id,
				user_id: this.user && this.user.id,
				role_id: this.roleId
			})
				.then(function(response) {
					self.resetting = false;
					self.confirmDialog = false;
					var mail = response.data && response.data.credentials_mail;
					if (mail && mail.sent) {
						self.showSnack(
							"Wachtwoord is gereset. Bevestiging is verstuurd naar " +
								mail.to +
								(mail.cc ? " (cc " + mail.cc + ")" : "") +
								".",
							"success"
						);
					} else {
						self.showSnack(
							"Wachtwoord is gereset, maar de bevestigingsmail is niet verstuurd.",
							"warning"
						);
					}
				})
				.catch(function(err) {
					self.resetting = false;
					self.showSnack(
						(err.response && err.response.data && err.response.data.msg) ||
							"Wachtwoord reset is mislukt.",
						"error"
					);
				});
		}
	}
};
</script>
